export default __webpack_public_path__ + "c757d3e2e72de9a62093a1843e711f4b.ttf";